import { gql } from '@apollo/client';

// 查詢兩個使用者的共同投票（支持多種排序方式）
// 默認返回最新的 10 個共同投票
export const GET_COMMON_VOTES = gql`
  query GetCommonVotes(
    $targetUserId: ID!
    $limit: Int
    $skip: Int
    $sameOptionOnly: Boolean
    $sortBy: CommonVotesSortBy
  ) {
    commonVotes(
      targetUserId: $targetUserId
      limit: $limit
      skip: $skip
      sameOptionOnly: $sameOptionOnly
      sortBy: $sortBy
    ) {
      success
      message
      totalCount
      commonVotes {
        question {
          id
          title
          description
          type
          options {
            text
            order
          }
          tags {
            id
            name
            description
          }
          createdAt
        }
        userVote {
          id
          articleId
          selectedOption
          votedAt
        }
        targetUserVote {
          id
          articleId
          selectedOption
          votedAt
        }
        isSameOption
        mostRecentVotedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 使用示例：
// 
// import { useQuery } from '@apollo/client';
// import { GET_COMMON_VOTES } from '../graphql/commonVotes';
//
// function CommonVotesComponent({ targetUserId }) {
//   const { loading, error, data } = useQuery(GET_COMMON_VOTES, {
//     variables: {
//       targetUserId: targetUserId,
//       limit: 10,         // 返回最新的 10 個共同投票（默認值）
//       skip: 0,           // 分頁偏移量
//       sameOptionOnly: false  // 設爲 true 只顯示相同選項的投票
//     }
//   });
//
//   if (loading) return <p>加載中...</p>;
//   if (error) return <p>錯誤: {error.message}</p>;
//   if (!data.commonVotes.success) {
//     return <p>{data.commonVotes.message}</p>;
//   }
//
//   return (
//     <div>
//       <h2>共同投票 (共 {data.commonVotes.totalCount} 個問題)</h2>
//       {data.commonVotes.commonVotes.map((cv, index) => (
//         <div key={index}>
//           <h3>{cv.question.title}</h3>
//           <p>我的選擇: {cv.question.options[cv.userVote.selectedOption].text}</p>
//           <p>對方的選擇: {cv.question.options[cv.targetUserVote.selectedOption].text}</p>
//           <p>選項相同: {cv.isSameOption ? '✅' : '❌'}</p>
//         </div>
//       ))}
//     </div>
//   );
// } 